import axios from '@axios'

export const state = {
  licensedCompanies: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allLicensedCompanies: (state) => state.licensedCompanies,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_LICENSED_COMPANY: (state, resp) => {
    if (!resp) return null
    state.licensedCompanies = resp.hasOwnProperty('licensedCompanys')
      ? resp.licensedCompanys
      : resp.licensedCompanies
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_LICENSED_COMPANY: (state, clearance) => {
    state.licensedCompanies = state.licensedCompanies.filter(
      (w) => w.id !== clearance.id
    )
  },
}

export const actions = {
  async getLicensedCompanies({ commit }, params = {}) {
    await axios
      .get('/api/licensed-companies', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_LICENSED_COMPANY', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_LICENSED_COMPANY',
          err.response.status === 404 ? { licensedCompanies: [] } : null
        )
      })
  },
  async createLicensedCompany({ commit }, licensedCompany) {
    return axios.post(`/api/licensed-companies`, licensedCompany)
  },
  async editLicensedCompany({ commit }, licensedCompany) {
    return axios.put(`/api/licensed-companies`, licensedCompany)
  },
  async deleteLicensedCompany({ commit }, licensedCompany) {
    await axios
      .delete(`/api/licensed-companies/${licensedCompany.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_LICENSED_COMPANY', licensedCompany)
        }
      })
  },
}
